import { createFileRoute, redirect } from "@tanstack/react-router";
import { useEffect } from "react";

import { HomePage } from "../components/home/HomePage";
import { legacyHomeSpaceId } from "../components/home/homePaths";
import { recordVisitedOrg, useActiveOrgId } from "../state/orgs";

/**
 * `/$org`: the organization's Home, its landing page above Chat and
 * Governance. Chat itself moved to `/$org/chat` (the rail's Chat item), which
 * opens the org's new-chat draft as this route used to.
 */
function OrgHomeRouteView() {
  const orgId = useActiveOrgId();
  useEffect(() => {
    if (orgId !== null) {
      recordVisitedOrg(orgId);
    }
  }, [orgId]);
  return <HomePage />;
}

/**
 * `?space=<id>` used to filter Home to one space. A space has its own page
 * now, so old links open it there; Home itself is always the whole
 * organization.
 */
export interface HomeSearch {
  readonly space?: string;
}

export const Route = createFileRoute("/_chat/$org/")({
  validateSearch: (search: Record<string, unknown>): HomeSearch => {
    const space = legacyHomeSpaceId(search);
    return space === null ? {} : { space };
  },
  beforeLoad: ({ params, search }) => {
    if (search.space) {
      throw redirect({
        to: "/$org/spaces/$spaceId",
        params: { org: params.org, spaceId: search.space },
        replace: true,
      });
    }
  },
  component: OrgHomeRouteView,
});
